// removed by extract-text-webpack-plugin
module.exports = {"footer":"src-components-Footer----footerStyles-module---footer---LfDhA","footerContainer":"src-components-Footer----footerStyles-module---footerContainer---2Z8Vt","fotter":"src-components-Footer----footerStyles-module---fotter---28jKD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/footerStyles.module.css
// module id = 295
// module chunks = 114276838955818